module.exports = __webpack_public_path__ + "static/media/buy_some_crypto.0c0695a4.png";